import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectoryHealthCareProvider } from "@/ContactDirectory/Models//DirectoryHealthCareProvider";
import { DirectorySelectableEntity } from "@/ContactDirectory/Models//DirectorySelectableEntity";
import { IDirectoryEntity } from "@/ContactDirectory/Models/IDirectoryEntity";
import { FaxDirectorySelectedHealthcareComponent } from "./FaxDirectorySelectedHealthcareComponent";
import { FaxDirectorySelectedSimpleComponent } from "./FaxDirectorySelectedSimpleComponent";

interface IFaxDirectorySelectedEntityComponentProps {
    entity: DirectorySelectableEntity<IDirectoryEntity>;
    selectedNumberId: string;
    setSelectedNumberId: (faxNumberId: string) => void;
    close: () => void;
    patientContactId?: string;
}

export function FaxDirectorySelectedEntityComponent(props: IFaxDirectorySelectedEntityComponentProps): JSX.Element {
    switch (props.entity?.type) {
        case DirectoryEntityType.Pharmacy:
        case DirectoryEntityType.Other:
            return (
                <FaxDirectorySelectedSimpleComponent
                    entity={props.entity}
                    selectedNumberId={props.selectedNumberId}
                    setSelectedNumberId={props.setSelectedNumberId}
                    close={props.close}
                    patientContactId={props.patientContactId}
                />
            );
        case DirectoryEntityType.HealthcareProvider:
            return (
                <FaxDirectorySelectedHealthcareComponent
                    healthcare={props.entity as DirectorySelectableEntity<DirectoryHealthCareProvider>}
                    setSelectedNumberId={props.setSelectedNumberId}
                    selectedNumberId={props.selectedNumberId}
                    close={props.close}
                />
            );
        default:
            return null;
    }
}
